import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import Loading from 'components/Loading'

export default function(route) {
  const Confirm = Loadable({
    loader: () => import('./Confirm'),
    render(loaded, props) {
      const Component = connect((state) => ({
        cashDeliveryConfirmState: state.cashDeliveryConfirmState,
        siteConfig: state.siteConfig
      }), {
        init
      })(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/confirm`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <Confirm {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
